import React from "react";

interface HamburgerProps {}

const Hamburger: React.FC<HamburgerProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M3.75 6.42773H20.25M3.75 12.4277H20.25M3.75 18.4277H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Hamburger;
